var render = function render(){var _vm=this,_c=_vm._self._c;return _c('complex-select',{attrs:{"tb-head":_vm.Head,"tb-data":_vm.Data,"key-str":_vm.keyword},on:{"select":_vm.onSelect},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }